import React, { useState, useEffect } from "react";
import { Layout, Menu, Card, Typography } from "antd";
import { motion, AnimatePresence } from "framer-motion";
import pose from "../../Assets/Tool/pose.jpg";

const { Sider, Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const DummyTool = () => {
  const mobileBreakpoint = 768;

  const [selectedKey, setSelectedKey] = useState("home");
  const [isMobile, setIsMobile] = useState(false);

  // Responsive Handler
  useEffect(() => {
    const updateUI = () => setIsMobile(window.innerWidth < mobileBreakpoint);
    updateUI();
    window.addEventListener("resize", updateUI);
    return () => window.removeEventListener("resize", updateUI);
  }, []);

  const handleLeftMenu = (e) => setSelectedKey(e.key);

  const siderWidth = isMobile ? "100%" : "200px";

  // Animations
  const fadeSlide = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
    exit: { opacity: 0, y: -20, transition: { duration: 0.4 } },
  };

  const sectionStyle = {
    marginBottom: "50px",
    paddingBottom: "20px",
    borderBottom: "1px solid #ddd",
  };

  const imageBox = {
    width: "100%",
    height: "250px",
    border: "1px solid #000",
    margin: "15px 0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "20px",
    background: "#f9f9f9",
  };

  const title = {
    fontSize: "26px",
    fontWeight: "bold",
    marginBottom: "10px",
  };

  const subTitle = {
    fontSize: "20px",
    fontWeight: "600",
    marginTop: "20px",
  };

  const listItem = {
    marginBottom: "10px",
    lineHeight: "1.6",
  };
  const pages = {
    home: (
      <>
        <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
          {/* 1. Yoga Instructor */}
          <div style={sectionStyle}>
            <div style={title}>1. Yoga Instructor</div>
            <p>Yoga without a trainer is like a journey without a guide.</p>

            <div style={imageBox}>image</div>

            <ul>
              <li style={listItem}>
                <strong>Correct posture and alignment:</strong> They correct
                your body’s alignment and prevent injuries.
              </li>
              <li style={listItem}>
                <strong>Personalized information:</strong> They adapt the
                exercises to each person’s unique needs (injuries, stiffness).
              </li>
              <li style={listItem}>
                <strong>Motivation and encouragement:</strong> They encourage
                you at the right time and help you try challenging poses.
              </li>
              <li style={listItem}>
                <strong>Safety:</strong> They protect you from dangerous poses
                and guide you to progress gradually.
              </li>
            </ul>

            <p>
              <strong>Note:</strong>
            </p>
            <ol>
              <li>
                Doing yoga with the help of a yoga expert or yoga trainer near
                you will help you avoid injuries, pain, and muscle cramps.
              </li>
              <li>
                Also, their help will help you improve your practice and learn
                yoga asanas quickly.
              </li>
              <li>
                They will take you under control, guide you well, and gradually
                progress you from beginner to intermediate and advanced yoga
                levels.
              </li>
              <li>
                It is your duty to choose a good and qualified yoga expert.
              </li>
              <li>
                5. Even if you get a good yoga expert, it is your duty to be a
                good student. Daily practice, even if obstacles come, it is
                necessary to try again.
              </li>
            </ol>
          </div>

          {/* 2. Yoga Block / Brick */}
          <div style={sectionStyle}>
            <div style={title}>2. Yoga Block / Brick</div>
            <p>
              This is like a “stretcher” that extends the floor when your hands
              don’t reach the floor.
            </p>

            <div style={imageBox}>image</div>

            <ul>
              <li style={listItem}>
                <strong>Access:</strong> Makes difficult poses like Sirasasana
                (Headstand) easier.
              </li>
              <li style={listItem}>
                <strong>Depth:</strong> Allows for deep muscle stretching in
                poses like Forward Fold.
              </li>
              <li style={listItem}>
                <strong>Balance:</strong> Helps maintain balance in standing
                poses.
              </li>
              <li style={listItem}>
                <strong>Strengthening:</strong> Strengthens muscles by using
                them as resistance in some exercises.
              </li>
            </ul>
          </div>

          {/* 3. Wall */}
          <div style={sectionStyle}>
            <div style={title}>3. Wall</div>
            <p>A wall is a stable and reliable yoga partner.</p>

            <div style={imageBox}>image</div>

            <ul>
              <li style={listItem}>
                <strong>Balance & Support:</strong> Helps you relax completely
                in poses like Legs-Up-the-Wall Pose.
              </li>
              <li style={listItem}>
                <strong>Alignment:</strong>Helps you learn proper alignment of
                your knees, hips, and shoulders by placing your heels on the
                wall in standing poses.
              </li>
              <li style={listItem}>
                <strong>Deep Stretching:</strong> Use a wall to provide deep
                stretches for the chest, shoulders, and spine.
              </li>
            </ul>
          </div>

          {/* 4. Yoga Stretch Belt */}
          <div style={sectionStyle}>
            <div style={title}>4. Yoga Stretch Belt</div>
            <p>
              This belt is an excellent tool for properly stretching stretched
              muscles and deepening asanas.
            </p>
            <p>
              This is a tool that increases the rapid extension of your arms.
            </p>

            <div style={imageBox}>image</div>

            <ul>
              <li style={listItem}>
                <strong>Access:</strong> Helps you easily access your legs in
                poses that are difficult to hold (e.g., Hero Pose).
              </li>
              <li style={listItem}>
                <strong>Maintaining Stretch:</strong> Helps you maintain a
                stretch for a longer period of time without holding your muscles
                rigid while stretching.
              </li>
              <li style={listItem}>
                <strong>Injury Management:</strong> Allows for safe practice for
                those with shoulder or hamstring injuries.
              </li>
            </ul>
          </div>

          {/* 5. Yoga Wheel */}
          <div style={sectionStyle}>
            <div style={title}>5. Yoga Wheel</div>
            <p>This is a powerful massage tool for the spine and chest area.</p>

            <div style={imageBox}>image</div>

            <ul>
              <li style={listItem}>
                <strong>Spinal Flexibility:</strong>Helps to flex the spine and
                regain its flexibility.
              </li>
              <li style={listItem}>
                <strong>Chest Opening:</strong> Helps to open the chest and
                shoulder areas, especially for those who sit for long hours.
              </li>
              <li style={listItem}>
                <strong>Massage:</strong> Provides a deep massage to tight
                muscles in areas such as the back, shoulders, and buttocks.
              </li>
            </ul>
          </div>

          {/* 6. Chair */}
          <div style={sectionStyle}>
            <div style={title}>6. Chair</div>
            <p>
              Chair yoga is a unique practice method that makes yoga accessible
              to everyone.
            </p>

            <div style={imageBox}>image</div>

            <ul>
              <li style={listItem}>
                <strong>Suitable for everyone:</strong> It is very safe for the
                elderly, those with injuries, or those with balance problems.
              </li>
              <li style={listItem}>
                <strong>Support:</strong>The chair provides support, allowing
                you to do poses with added stability.
              </li>
              <li style={listItem}>
                <strong>Strength & Flexibility:</strong> Using a chair, you can
                strengthen and stretch many areas such as the arms, legs, and
                spine.
              </li>
            </ul>
          </div>

          {/* Conclusion */}
          <div style={{ marginTop: "40px" }}>
            <div style={subTitle}>In conclusion:</div>
            <p>
              These tools will not only enhance your training, but also make it
              safer, more efficient, and more enjoyable. They do not replace the
              role of the trainer, but are great tools to help you follow his or
              her instructions.
            </p>
          </div>
        </div>
      </>
    ),
    left1: (
      <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
        <div style={sectionStyle}>
          <div style={title}>Yoga Block / Brick</div>
          <h3>1. Align the body for support</h3>
          <p>Trikonasana - Triangle Pose</p>
          <div style={imageBox}>image</div>
          <p>
            <b>Benefits:</b> Place your lower hand on the block, stretch your
            back, and maintain balance.
          </p>
        </div>
        <div style={sectionStyle}>
          <h3>2. Ardha Chandrasana - Half Moon Pose</h3>
          <div style={imageBox}>image</div>
          <p>
            <b>Benefits:</b> With your lower hand on the block, you can easily
            control your balance.
          </p>
        </div>
      </div>
    ),
    left2: (
      <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
        <div style={sectionStyle}>
          <div style={title}>Wall</div>
          <h3>1. For Balance & Strength</h3>
          <p>
            சுவர் மிகச் சிறந்த யோகா உதவிக்கருவி, இது சமநிலை, ஆதாரம் மற்றும்
            ஆழமான இழுவைக்கு உதவுகிறது.
          </p>
          <p>
            <b>1. Handstand with Wall Support</b>
          </p>
          <div style={imageBox}>image</div>
          <p>
            <b>Benefits:</b> Strengthen your arms and practice balance.
          </p>
        </div>
        <div style={sectionStyle}>
          <h3>2. Legs Up the Wall Pose (Viparita Karani)</h3>
          <div style={imageBox}>image</div>
          <p>
            <b>Benefits:</b> Reduce leg fatigue, improve circulation, and find
            peace of mind.
          </p>
        </div>
      </div>
    ),
    left3: (
      <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
        <div style={sectionStyle}>
          <div style={title}>5. Yoga Stretch Belt</div>
          <h3>1. For Arms & Shoulder Opening</h3>
          <p>
            <b>1. Cow Face Pose (Gomukhasana)</b>
          </p>
          <div style={imageBox}>image</div>
          <p>
            <b>Benefits:</b> With the help of the strap, you can hold your hands
            behind your back. It opens your shoulders.
          </p>
        </div>
      </div>
    ),
    left4: (
      <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
        <div style={sectionStyle}>
          <div style={title}>Yoga Wheel</div>
          <p>
            Using a yoga wheel is a great way to increase back flexibility, open
            the chest, and build balance and strength.
          </p>
          <h3>Backbends & Chest Openers</h3>
          <p>
            <b>1.Supported Backbend:</b>
          </p>
          <div style={imageBox}>image</div>
          <p>
            Sit on the wheel, keeping your back straight and your head behind
            you.
          </p>
          <p>
            As you exhale, rest your back on the wheel and extend your arms
            behind your head or across your chest.
          </p>
        </div>
        <div style={sectionStyle}>
          <p>
            <b>2.Full Wheel Pose (Urdhva Dhanurasana):</b>
          </p>
          <div style={imageBox}>image</div>
          <p>
            From the above pose, extend your arms behind your head and place
            them on the floor. This is easier than Full Wheel Pose.
          </p>
        </div>
      </div>
    ),
    left5: (
      <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
        <div style={sectionStyle}>
          <div style={title}>Chair</div>
          <p>
            Chair Yoga is great for the elderly, those with physical
            disabilities, office workers, or those who are unable to practice
            standing. It reduces stress on the joints.
          </p>
          <h3>chair yoga:</h3>
          <p>Breathing & Warm-up</p>
          <p>
            <b>1.Easy Pose on Chair:</b>
          </p>
          <div style={imageBox}>image</div>
          <p>
            Sit straight in a chair, legs crossed (if possible). Start by
            closing your eyes and taking a few deep breaths.
          </p>
        </div>
      </div>
    ),
  };
  const selectedContent = pages[selectedKey];
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{
        padding: "50px 20px",
        background: "linear-gradient(to bottom right, #f0f9ff, #fff)",
        minHeight: "100vh",
       
        fontSize: "18px",
        lineHeight: "1.8",
      }}
    >
      <Layout
        style={{
          width: isMobile ? "100%" : "90%",
          maxWidth: "1340px",
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          overflow: "hidden",
          height: "auto",
        }}
      >
        {/* 🌿 LEFT SIDEBAR */}
        <motion.div
          initial={{ x: -80, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          style={{
            width: isMobile ? "100%" : "200px",
            height: isMobile ? "auto" : "100%",
          }}
        >
          <Sider
            width={isMobile ? "100%" : 230}
            style={{
              position: isMobile ? "relative" : "sticky",
              top: isMobile ? "0px" : "64px", // FIXED
              marginTop: isMobile ? "60px" : "40px",
              height: isMobile ? "auto" : "calc(100vh - 64px)",
              minHeight: isMobile ? "250px" : "unset",
              backgroundImage: `url(${pose})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              overflow: "hidden",
              borderRight: isMobile
                ? "none"
                : "1px solid rgba(255,255,255,0.2)",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.6)",
                zIndex: 1,
              }}
            />

            {/* 🌿 Sidebar Content */}
            <div
              style={{
                position: "relative",
                zIndex: 2,
                padding: "16px",
                fontWeight: "bold",
                textAlign: "center",
                color: "#fff",
                fontSize: "1rem",
                letterSpacing: "0.5px",
                textShadow: "0 1px 3px rgba(0,0,0,0.8)",
              }}
            >
              {" "}
              Breathe Techniques
            </div>

            <Menu
              theme="transparent"
              mode="inline"
              style={{
                background: "transparent",
                color: "#fff",
                fontSize: "1.1rem",
                position: "relative",
                zIndex: 2,
                fontWeight: 500,
                textAlign: "center",
              }}
              onClick={handleLeftMenu}
              selectedKeys={[selectedKey]}
              items={[
                {
                  key: "left1",
                  label: "Yoga Block / Brick",
                },
                {
                  key: "left2",
                  label: "Wall",
                },
                {
                  key: "left3",
                  label: "Yoga Stretch Belt",
                },
                {
                  key: "left4",
                  label: "Yoga Wheel",
                },
                {
                  key: "left5",
                  label: "Chair",
                },
                {
                  key: "home",
                  label: "Back to Mainpage",
                },
              ]}
            />
          </Sider>
        </motion.div>

        {/*  MAIN CONTENT */}
        <Content
          style={{
            flex: 1,
            padding: isMobile ? "10px" : "30px 40px",
            width: "100%",

            background: "#fff",
            textAlign: "left",
          }}
        >
          <AnimatePresence mode="wait">
            <motion.div
              key={selectedKey}
              variants={fadeSlide}
              initial="hidden"
              animate="visible"
              exit="exit"
            >
              {selectedContent}
            </motion.div>
          </AnimatePresence>
        </Content>
      </Layout>
    </motion.div>
  );
};

export default DummyTool;
